module.exports = __webpack_public_path__ + "static/media/test17_1.3bf9283c.png";